
import React, { useState, useEffect } from 'react';
import './WorkH.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/swiper-bundle.css';
import styled from 'styled-components'
import roadmap from "../assets/road-map.jpg"
import resume from '../assets/Mohammed Arfa Uruj Resume.pdf'
import hover from "../assets/hover.png"

const experiences = [
  {
    title: "Lead Research Engineer – CSUSB (Research & Engineering)",
    location: "San Bernardino, CA",
    dates: "Aug 2024 – Present",
    details: "As the Lead Research Engineer at CSUSB, I have played a pivotal role in automating research workflows, advancing AI and machine learning techniques, and improving team efficiency. I spearheaded the development of a production-ready LLM system integrated with Retrieval-Augmented Generation (RAG), reducing search-to-synthesis time by 50%, accelerating the insight generation process across various academic datasets. Through containerizing LLM workflows using Docker and Flask, I enabled reproducible experimentation across multiple research teams, cutting model iteration time by 60%. Additionally, I implemented robust CI/CD pipelines and health monitoring systems, achieving 99.9% platform uptime for AI-driven tools and infrastructures. I also ensured the security and compliance of the backend by implementing Supabase RLS, token-based authentication, and encrypted data flows, making the platform adhere to academic standards."
  },
  {
    title: "Project Manager – Fin-Tastic Division (Academic)",
    location: "San Bernardino, CA",
    dates: "Jan 2024 – May 2024",
    details: "As the Project Manager for Fin-tastic Division, I led the development and successful launch of a mobile math game on the Amazon Appstore. I managed the project end-to-end, ensuring a seamless and engaging user experience through Unity and C# for game development. I also integrated Google AdMob for monetization while maintaining a user-friendly interface. To support user data storage and sync across devices, I designed a scalable Azure App Services solution. I implemented secure account transfer functionality, allowing users to access game progress on multiple devices. I also led the team using agile methodologies, facilitating Scrum meetings, and utilizing Azure DevOps and GitHub for version control and continuous integration. This project enhanced my skills in game development, cloud computing, and agile leadership."
  },
  {
    title: "Software Engineering Intern – Astute Solutions",
    location: "Folsom, CA",
    dates: "Apr 2023 – July 2023",
    details: "As a Software Engineering Intern at Astute Solutions LLC, I contributed to the development of a full-stack web application. I designed and developed a responsive React.js frontend, improving performance and user experience by 20%. On the backend, I built a scalable Node.js architecture that enhanced application responsiveness. I implemented RESTful APIs to streamline data exchange between the frontend and backend, supporting real-time data retrieval and dynamic content. Additionally, I optimized MongoDB queries and indexing strategies, reducing data retrieval load times by 15%. This experience strengthened my expertise in React.js, Node.js, MongoDB, and API development."
  },
  {
    title: "Software Engineering Intern – Ideacentrix",
    location: "Plano, TX",
    dates: "Jan 2022 – Dec 2022",
    details: "During my internship at Ideacentrix, I worked on optimizing real-time AI systems. I played a key role in refactoring the backend, shifting from Java to Python, which doubled the pipeline throughput and reduced latency significantly. Additionally, I focused on data integrity, reducing data corruption by 95% through the use of AES-256 encryption and implementing robust retry logic and integrity checks across distributed pipelines. I also developed a real-time compliance dashboard using AngularJS and AWS Lambda, which reduced incident response time by 40%. Finally, I worked on scaling the cloud-native architecture using Docker and AWS serverless components, which improved fault isolation and deployment speed."
  },
  {
    title: "Technical Lead – BooksPUD",
    location: "Hyderabad, India",
    dates: "Dec 2019 – Nov 2021",
    details: "As the Technical Lead at BooksPUD, a startup focused on personalized content delivery, I led the development of a real-time mobile platform that increased user engagement by 150%. I designed and implemented a TensorFlow-powered recommendation engine based on Neural Collaborative Filtering, which boosted conversion rates by 20%. I also optimized the backend by restructuring endpoints and improving database queries, reducing API latency by 70%. My responsibilities included overseeing the full-stack product delivery, from initial architecture design to product launch, including features like secure user authentication, Firebase integration, and analytics."
  }
];

const WorkH = () => {
  // State to hold window width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Use ternary operator to adjust slidesPerView based on window width
  const slidesPerViewNum = windowWidth < 640 ? 1 : 3;  // 1 slide for small screens, 3 slides for larger screens
  return (
    <section className="work-section" id="work">
      <IntroW>
        <h1>Check out my Work Experience!</h1>
      </IntroW>
      <ExpCont style={{ backgroundImage: roadmap }}>
        <SwipeInfoCont>Swipe to see other Experiences!</SwipeInfoCont>
        <Swiper
          spaceBetween={30}
          loop={true}
          slidesPerView={slidesPerViewNum}  // Default slides per view
          keyboard={{
            enabled: true,  // Enable keyboard navigation
            onlyInViewport: true,  // Optional: restrict keyboard navigation to the viewport
          }}
        //navigation={true}  // Enable navigation arrows
        >
          {experiences.map((exp, index) => (
            <SwiperSlide key={index}>
              <CardContent>
                <div className="work-entry">
                  <h3>{exp.title}</h3>
                  <p className="experience-location">{exp.location}</p>
                  <p className="experience-dates">{exp.dates}</p>
                  <img src={hover} className='hoverimg' />
                  <div className='work-details' dangerouslySetInnerHTML={{ __html: exp.details }} />
                </div>
              </CardContent>
            </SwiperSlide>
          ))}
        </Swiper>
      </ExpCont>
      <ResumeCont>
        <div>
          Check out My Resume!
        </div>
        <button>
          <a href={resume} download={resume}>Grab A Copy</a>
        </button>
      </ResumeCont>
    </section>
  );
};

export default WorkH;

const IntroW = styled.div`
    color: white;
    background: linear-gradient(#107896,#43abc9);
    padding-top: 8vh;
    padding-bottom: 5vh;
`

const ExpCont = styled.div`
    background-image: url(${roadmap});
    background-size: cover;
    padding: 8vh;
`
const CardContent = styled.div`
  background: linear-gradient(to bottom right, #caf1de, #acddde);
  border-radius: 100px;
  padding: 2vh;
`

const SwipeInfoCont = styled.div`
  padding-bottom: 5vh;
  font-size: 3em;
  font-weight: bold;
`

const ResumeCont = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5vh;
    div{
        margin-bottom: 5vh;
        font-size: 3em;
        color: white;
        @media(max-width: 767px){
            font-size: 1.5em;
        }
        @media(max-width: 281px){
            font-size: 1em;
        }
    }
    button{
        background: none;
        border: 3px solid rgb(221, 221, 221);
        padding: 2vh 5vh;
        &:hover{
            cursor: pointer;
            background: rgb(255, 255, 255, 0.2);
            padding: 2vh 6vh;
        }
    }
    a{
        text-decoration: none;
        color: rgb(221, 221, 221);
        font-size: 16px;
    }
`
